import React from "react";
import NewComment from "../../../posts/components/NewComment";
import { PostComment, PostsShowProps } from "../../../posts/lib/types";
import { SharedCurrentUser } from "../../lib/types";
import LightbulbIcon from "../icons/LightbulbIcon";

import { HStack, Link, Stack, Text } from "@chakra-ui/react";
import {
  newProfilePersonalInfoApplicationPath,
  newUserDatabaseAuthenticationRegistrationPath,
  newUserDatabaseAuthenticationSessionPath,
} from "../../../../../routes";
import Button from "../ui/Button";
import { Box } from "../ui/chakra";

const FetchedComments = ({
  comments,
  currentUser,
  post,
}: {
  comments: PostComment[];
  currentUser: SharedCurrentUser;
  post: PostsShowProps;
}) => {
  return (
    <>
      {currentUser?.is_all_public_feature_accessible ? (
        <Stack gap={5} mt={2}>
          {[...comments].reverse().map((comment) => (
            <NewComment
              comment={comment}
              key={comment.code}
              currentUser={currentUser}
              post={post}
            />
          ))}
        </Stack>
      ) : (
        <Box mt={2}>
          <Box bgColor="brand.100" borderRadius="4px" pt={6} pb={7} px={6}>
            <Stack gap={4}>
              <Stack gap={2} align="center">
                <LightbulbIcon boxSize={8} color={"brand.300"} />

                {post.comments_count > 0 && currentUser != null ? (
                  <Text textAlign="center" fontSize={{ base: "sm", md: "md" }}>
                    本人確認が完了すると、コメントを閲覧したり、
                    <br />
                    質問を投稿することができます
                  </Text>
                ) : post.comments_count > 0 && currentUser == null ? (
                  <Text textAlign="center" fontSize={{ base: "sm", md: "md" }}>
                    会員登録が完了すると、コメントを閲覧したり、
                    <br />
                    質問を投稿することができます
                  </Text>
                ) : (
                  <Text textAlign="center" fontSize={{ base: "sm", md: "md" }}>
                    この質問にはまだ回答がついていません。
                    <br />
                    ぜひ、あなたの見解や経験をコメントしてください。
                  </Text>
                )}
              </Stack>
              {currentUser?.is_temporary &&
                !currentUser.personal_info_applicationing && (
                  <Stack gap={3} align="center">
                    <Button
                      as="a"
                      href={newProfilePersonalInfoApplicationPath()}
                      textDecoration="none"
                    >
                      <Box as="span" fontWeight="bold">
                        本人確認を申請する
                      </Box>
                    </Button>
                  </Stack>
                )}
              {currentUser == null && (
                <Stack gap={3} align="center">
                  <Button
                    as="a"
                    href={newUserDatabaseAuthenticationRegistrationPath()}
                    textDecoration="none"
                  >
                    <HStack>
                      <Text fontWeight="bold" color="white">
                        まずは会員登録
                      </Text>
                      <Box
                        bgColor="white"
                        borderRadius="2px"
                        px={1}
                        pt={"1px"}
                        pb={0}
                      >
                        <Box
                          color="brand.500"
                          fontSize="xs"
                          fontWeight="bold"
                          letterSpacing="3%"
                        >
                          無料
                        </Box>
                      </Box>
                    </HStack>
                  </Button>
                  <Link
                    href={newUserDatabaseAuthenticationSessionPath()}
                    color="textLink"
                    fontSize="sm"
                  >
                    すでに会員の方は、こちらからログイン
                  </Link>
                </Stack>
              )}
            </Stack>
          </Box>
        </Box>
      )}
    </>
  );
};

export default FetchedComments;
